import { useEffect, useRef, useState } from 'react';
import { useCanUseAiFeatures } from './useCanUseAiFeatures';
import { getIsNLSSearchOnFromLocalStorage } from './utils';
import { NLS_SEARCH_KEY_LOCAL_STORAGE } from './constants';
import { resetStickySearchInAssetbank } from '../helpers/searchUtils';

export const useNLSSearch = (isStickySearch: boolean) => {
	const [isNLSSearchOn, setIsNLSSearchOn] = useState<boolean>(() =>
		getIsNLSSearchOnFromLocalStorage(),
	);

	const { canUseNLSSearch } = useCanUseAiFeatures();

	const isPerformingNLSSearch = canUseNLSSearch && isNLSSearchOn;

	useEffect(() => {
		localStorage.setItem(NLS_SEARCH_KEY_LOCAL_STORAGE, JSON.stringify(isNLSSearchOn));
	}, [isNLSSearchOn]);

	useEffect(() => {
		// We don't want to reset search on first render
		if (isStickySearch && !itIsFirstRender.current) {
			resetStickySearchInAssetbank(!isPerformingNLSSearch); // "!" because if now it is doing an NLS search, it means that what was previously being applied (and hence what we need to reset) was NOT an NLS search (and viceversa)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isPerformingNLSSearch]);

	const itIsFirstRender = useRef(true);
	// This effect needs to be the last one (otherwise, itIsFirstRender would incorrectly be false on the first render when the other effects run, because they would run after this one, that sets it to false)
	useEffect(() => {
		itIsFirstRender.current = false;
	}, []);

	return { canUseNLSSearch, isNLSSearchOn, setIsNLSSearchOn };
};
